export enum CREACION_USUARIO_TYPES {
  FORM_HANDLE_CHANGE = 'FORM_HANDLE_CHANGE',
  FORM_VERIFY_CODE_HANDLE_CHANGE = 'FORM_VERIFY_CODE_HANDLE_CHANGE',
  FORM_ADD_ERROR = 'FORM_ADD_ERROR',
  FORM_CHANGE_PAGE = 'FORM_CHANGE_PAGE',
  FORM_ADD_ERROR_VERIFY_CODE = 'FORM_ADD_ERROR_VERIFY_CODE',
  FORM_CLEAR = 'FORM_CLEAR',
}
